import axios from "axios";

import { auth } from "@Firebase/firebase";
import { CreateRoleRequest, Role } from "@Types/roles";
import { HttpQuery, PaginatedResult } from "@Types/http";

import { queryClient } from "../App";

export const getRoles = (
  query?: HttpQuery
): (() => Promise<PaginatedResult<Role[]>>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_role/`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );

    return {
      docs: response.data.result?.docs ?? [],
      totalDocs: response.data.result?.totalDocs ?? 0,
      totalPages: response.data.result?.totalPages ?? 0,
    };
  };
};

export const getRole = (id: string): (() => Promise<Role>) => {
  return async () => {
    const token = await auth.currentUser?.getIdToken();
    const response = await axios.get(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_role/${id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.result;
  };
};

export const updateRole = (): ((role: Role) => Promise<Role>) => {
  return async (role) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.put(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_role/${role._id}`,
      role,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    queryClient.setQueryData<Role>(
      [`role-${role._id}`],
      () => response.data.result
    );
    return response.data.result;
  };
};
export const deleteRole = (): ((role: Role) => Promise<Role>) => {
  return async (role) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.delete(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_role/${role._id}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
};

export const createRole = (): ((role: CreateRoleRequest) => Promise<Role>) => {
  return async (role) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.post(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_role/`,
      role,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
};
